import { render, staticRenderFns } from "./EducationalCategoryInterestData.vue?vue&type=template&id=1122ff26&"
import script from "./EducationalCategoryInterestData.vue?vue&type=script&lang=js&"
export * from "./EducationalCategoryInterestData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports